import { gsap } from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { Flip } from 'gsap/Flip';
gsap.registerPlugin(ScrollTrigger, MorphSVGPlugin, ScrollToPlugin, Flip);

import { disablePageScroll, enablePageScroll } from '@fluejs/noscroll';

class Druppel {
	constructor() {
		window.addEventListener('DOMContentLoaded', (event) => {
			this.init();
		});
	}

	init() {
		this.scrollToButton = document.querySelector('[data-scroll-to-button]');
		this.scrollToButton?.addEventListener('click', (e) => {
			e.preventDefault();

			gsap.to(window, {
				duration: 2,
				ease: 'power2.inOut',
				scrollTo: {
					y: document.querySelector(this.scrollToButton.dataset.scrollToButton),
					offsetY: 100,
				},
			});
		});

		this.formWrapper = document.querySelector('[data-druppel-form-wrapper]');
		this.druppelForm = this.formWrapper.querySelector('[data-druppel-form]');
		this.druppelFormElement = this.druppelForm?.querySelector('form');
		this.druppelFormId = this.druppelFormElement?.dataset?.formid;

		this.plungeDrop = document.querySelector('[data-plunge]');
		gsap.set(this.plungeDrop, { transformOrigin: 'center center' });

		this.druppel = document.querySelector('[data-druppel]');
		this.confirmationMessage = this.druppel.querySelector('[data-confirmation-message]');
		this.druppelSvg = this.druppel.querySelector('#druppel');
		this.druppelLogo = document.querySelector('#druppel-logo');
		this.druppelShape = this.druppel.querySelector('#druppel-shape');

		this.bucket = document.querySelector('[data-bucket]');
		this.waterHeightRelatedToEntries = this.bucket?.dataset.bucketWaterHeightRelatedToEntries;
		this.submissionCount = this.bucket?.querySelector('[data-submission-count]');
		this.emmerFeedback = document.querySelector('[data-emmer-feedback]');

		gsap.set(this.emmerFeedback, { yPercent: 100, opacity: 1 });

		gsap.set(this.druppelSvg, { scale: 0.2 });
		gsap.set(this.druppelLogo, { scaleX: 0.5, scaleY: 0.7, yPercent: -15, opacity: 0 });

		this.triggerTimeline = gsap.timeline({
			paused: true,
			scrollTrigger: {
				// markers: true,
				start: 'top bottom',
				end: 'bottom bottom',
				trigger: this.druppel,
				scrub: 2,
			},
		});

		this.triggerTimeline.to(this.druppelSvg, {
			scale: 1,
			duration: 1,
			ease: 'power2.inOut',
		});

		this.triggerTimeline.to(
			this.druppelLogo,
			{
				opacity: 1,
				scaleX: 1,
				scaleY: 1,
				yPercent: 0,
				duration: 0.8,
				ease: 'power2.inOut',
			},
			0
		);

		// Event Listeners
		gform.utils.addAsyncFilter('gform/submission/pre_submission', async (data) => {
			if (data?.form?.dataset?.formid !== this.druppelFormId) {
				return data;
			}

			await this.releaseFromFaucet();
			return data;
		});

		gform.utils.addAsyncFilter('gform/ajax/post_ajax_submission', async (data) => {
			if (data?.form?.dataset?.formid !== this.druppelFormId) {
				return data;
			}

			if (data.submissionResult.data) {
				if (data.submissionResult.data.is_valid) {
					this.fallIntoBucket();
				} else {
					this.backToFaucetBecauseOfError();
				}
			}

			return data;
		});
	}

	releaseFromFaucet() {
		return new Promise((resolve) => {
			this.triggerTimeline.kill();

			gsap.set(this.formWrapper, {
				minHeight: this.druppelForm.offsetHeight + 'px',
			});

			gsap.set(this.druppelShape, {
				transformOrigin: 'center center',
			});

			document.dispatchEvent(new Event('prevent-menu-stick'));
			disablePageScroll();
			const duration = 2;

			const tl = gsap.timeline({
				delay: 0,
				onComplete: () => {
					resolve();
				},
			});

			tl.to(this.druppelForm, {
				scale: 0.5,
				opacity: 0,
				duration: duration / 6,
				ease: 'power2.out',
			});

			tl.to(this.confirmationMessage, {
				opacity: 1,
				duration: duration / 6,
				ease: 'power2.inOut',
			});

			tl.to(
				this.druppelLogo,
				{
					opacity: 0,
					scale: 0.5,
					yPercent: 15,
					duration: duration / 6,
					ease: 'power2.out',
				},
				0
			);

			tl.to(
				this.druppelSvg,
				{
					scale: 1,
					duration: duration / 6,
					ease: 'power2.inOut',
				},
				0
			);

			tl.to(
				this.druppelShape,
				{
					morphSVG:
						'M870 1235c0 239.726-195.289 435-435 435-239.726 0-435-195.289-435-435 0-239.726 195.289-435 435-435 239.726 0 435 195.289 435 435z',
					duration: duration / 6,
					ease: 'power2.inOut',
				},
				0
			);

			tl.to(
				this.druppelShape,
				{
					scale: 0.5,
					duration: duration * 0.75,
					ease: 'elastic.out(1.2, 0.3)',
				},
				0
			);

			tl.to(
				window,
				{
					duration: duration / 3,
					ease: 'power2.out',
					scrollTo: {
						y: this.confirmationMessage,
						offsetY: (window.innerHeight - this.confirmationMessage.offsetHeight) / 2,
					},
				},
				0
			);
		});
	}

	backToFaucetBecauseOfError() {
		return new Promise((resolve) => {
			const duration = 3;

			const tl = gsap.timeline({
				delay: 0,
				onComplete: () => {
					document.dispatchEvent(new Event('resume-menu-stick'));
					enablePageScroll();
					resolve();
				},
			});

			tl.to(this.confirmationMessage, {
				opacity: 0,
				duration: duration / 6,
				ease: 'power2.inOut',
			});

			tl.to(
				this.druppelLogo,
				{
					opacity: 1,
					scale: 1,
					yPercent: 0,
					duration: duration / 6,
					ease: 'power2.inOut',
				},
				0
			);

			tl.to(
				this.druppelSvg,
				{
					scale: 1,
					duration: duration / 6,
					ease: 'power2.inOut',
				},
				0
			);

			tl.to(
				this.druppelShape,
				{
					morphSVG:
						'M435 0C220.196 704.518 7.943 880.25.152 1235-6.35 1531.125 195.358 1670 435 1670c239.642 0 441.35-138.875 434.848-435C862.058 880.25 649.804 704.518 435 0z',
					scale: 1,
					duration: duration / 6,
					ease: 'power2.inOut',
				},
				0
			);

			tl.to(
				this.druppelForm,
				{
					scale: 1,
					opacity: 1,
					duration: duration / 8,
					ease: 'power2.inOut',
				},
				0
			);

			tl.to(window, {
				duration: duration / 3,
				ease: 'power2.inOut',
				scrollTo: {
					y: this.druppelForm,
					offsetY: Math.max(40, (window.innerHeight - this.druppelForm.offsetHeight) / 2),
				},
			});
		});
	}

	fallIntoBucket() {
		const duration = 0.8;

		gsap.to(window, {
			duration: (duration / 2) * 2.5,
			delay: (duration / 2) * 0.5,
			ease: 'power2.inOut',
			scrollTo: {
				y: this.bucket,
				offsetY: (window.innerHeight - this.bucket.offsetHeight) / 2,
			},
			onComplete: () => {
				document.dispatchEvent(new Event('resume-menu-stick'));
				enablePageScroll();
			},
		});

		gsap.to(this.confirmationMessage, {
			opacity: 0,
			scale: 0.2,
			duration: duration / 4,
			ease: 'power2.in',
		});

		const state = Flip.getState(this.druppelShape);
		const emmer = document.querySelector('#emmer');

		// Insert as second child (index 1)
		if (emmer.children.length >= 2) {
			emmer.insertBefore(this.druppelShape, emmer.children[1]);
		} else {
			emmer.appendChild(this.druppelShape);
		}

		gsap.set(this.druppelShape, {
			x: -82,
			y: this.waterHeightRelatedToEntries * -1,
			yPercent: -24,
		});

		Flip.from(state, {
			duration: (duration / 2) * 3,
			nested: true,
			absolute: true,
			ease: 'power2.in',
			onComplete: () => {
				this.plunge();
			},
		});

		gsap.to(this.druppelShape, {
			morphSVG:
				'M435 730.625C408.15 818.69 381.618 840.656 380.644 885c-.812 37.016 24.4 54.375 54.356 54.375 29.955 0 55.169-17.36 54.356-54.375-.973-44.344-27.505-66.31-54.356-154.375z',
			duration: (duration / 2) * 2.5,
			ease: 'power2.inOut',
		});
	}

	screenRectFromPath(path) {
		const svg = path.ownerSVGElement;
		const bbox = path.getBBox();
		const ctm = path.getScreenCTM();
		const p = svg.createSVGPoint();
		const corners = [
			[bbox.x, bbox.y],
			[bbox.x + bbox.width, bbox.y],
			[bbox.x + bbox.width, bbox.y + bbox.height],
			[bbox.x, bbox.y + bbox.height],
		].map(([x, y]) => {
			p.x = x;
			p.y = y;
			return p.matrixTransform(ctm);
		});
		const xs = corners.map((p) => p.x);
		const ys = corners.map((p) => p.y);
		return {
			left: Math.min(...xs),
			top: Math.min(...ys),
			width: Math.max(...xs) - Math.min(...xs),
			height: Math.max(...ys) - Math.min(...ys),
		};
	}

	plunge() {
		const plungeTl = gsap.timeline({
			repeat: 0,
			delay: 0.2,
		});

		plungeTl.to(this.plungeDrop, {
			yPercent: -300,
			ease: 'elastic.out(2.5, 0.75)',
			duration: 2,
		});

		plungeTl.to(
			this.plungeDrop,
			{
				opacity: 0,
				duration: 0.3,
				ease: 'power2.out',
			},
			0.5
		);

		gsap.to(this.emmerFeedback, {
			yPercent: 0,
			duration: 2,

			delay: 0.5,
			ease: 'elastic.out(1.1, 0.8)',
		});

		const newCount = parseInt(this.submissionCount.dataset.submissionCount, 10) + 1;
		this.submissionCount.dataset.submissionCount = newCount;
		this.submissionCount.innerHTML = new Intl.NumberFormat('nl-NL').format(newCount);
	}
}

// Initialize the Druppel class
new Druppel();
